
/*
 |--------------------------------------------------------------------------
 | Laravel Spark Components
 |--------------------------------------------------------------------------
 |
 | Here we will load the Spark components which makes up the core client
 | application. This is also a convenient spot for you to load all of
 | your components that you write while building your applications.
 */

require('./../spark-components/bootstrap');


Vue.component('app-toolbar', require('./global/AppToolbar.vue').default);
Vue.component('drawer-left', require('./global/LeftDrawer.vue').default);

Vue.component('chat-room', require('./interface/ChatRoom.vue').default);


Vue.component('settings-form', require('./settings/SettingsForm.vue').default);

Vue.component('breakout-admin-create', require('./settings/BreakoutCreate.vue').default);
Vue.component('breakout-admin-list', require('./settings/BreakoutList.vue').default);
